import type { FC } from 'react';
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import noop from '@wix/da-shared-react/pkg/utils/noop';
import { BatchActionProps } from '../types';
import MobileBatchActionWrapper from '../MobileBatchActionWrapper';
import DesktopBatchActionWrapper from '../DesktopBatchActionWrapper';

export interface Props extends BatchActionProps {}

const DefaultBatchEdit: FC<Props> = ({ selectionArea }) => {
  const isMobile = useContext(MobileContext);

  if (isMobile) {
    return <MobileBatchActionWrapper onSave={noop} />;
  }

  return (
    <DesktopBatchActionWrapper selectionArea={selectionArea} onSave={noop} />
  );
};
DefaultBatchEdit.displayName = 'DescriptionBatchEdit';

export default DefaultBatchEdit;
